document.addEventListener('DOMContentLoaded',()=>{
  const drawer=document.querySelector('.cart-drawer'),overlay=document.querySelector('.cart-overlay');
  document.querySelectorAll('[data-cart-open]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();drawer?.classList.add('open');overlay?.classList.add('show')}));
  document.querySelectorAll('[data-cart-close]').forEach(b=>b.addEventListener('click',()=>{drawer?.classList.remove('open');overlay?.classList.remove('show')}));
  overlay?.addEventListener('click',()=>{drawer?.classList.remove('open');overlay?.classList.remove('show')});
  document.querySelectorAll('[data-add-to-cart]').forEach(btn=>btn.addEventListener('click',async()=>{
    const id=btn.dataset.variant;
    if(!id)return;
    btn.disabled=true; btn.textContent='ADDING…';
    try{
      await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})});
      btn.textContent='ADDED ✓'; setTimeout(()=>btn.textContent='QUICK ADD',1200);
      drawer?.classList.add('open');overlay?.classList.add('show');
    }catch(e){btn.textContent='TRY AGAIN'}finally{setTimeout(()=>btn.disabled=false,700)}
  }));
});